/**
 * @file 重命名删除菜单
 * @author sunyingying01
 */

import React from 'react';
import {observer} from 'mobx-react-lite';
import {Dropdown, Tooltip} from 'antd';
import MoreIcon from '@/assets/icons/moreIcon.svg';
import RenameSvg from '@/assets/icons/rename.svg';
import DeleteSvg from '@/assets/icons/delete.svg';
import CopySvg from '@/assets/icons/jobCopy.svg';
import JobCopyDisSvg from '@/assets/icons/jobCopyDis.svg';
import styles from './index.module.less';

interface ActionMenuProps {
  onRename?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  showCopy?: boolean;
  disabled?: boolean;
  disableCopy?: boolean;
  disableRename?: boolean;
  disableDelete?: boolean;
  copyDisabledTooltip?: string;
  onOpenChange?: (val: boolean) => void;
  trigger?: ['click' | 'hover'];
}

// eslint-disable-next-line complexity
const RenameDeleteMenu: React.FC<ActionMenuProps> = observer(({
    onRename, onDelete, onCopy, showCopy = false, disabled = false, disableCopy = false,
    disableRename = false, disableDelete = false, copyDisabledTooltip = '', onOpenChange, trigger = ['click']
}) => {
    const handleMenuClick = (e: any) => {
        // 阻止事件传播，但不阻止默认行为（让 Dropdown 能自动关闭）
        e.domEvent.stopPropagation();
        // 注意：不要 preventDefault()，否则会阻止 Dropdown 自动关闭

        if (e.key === 'rename' && onRename && !disableRename) {
            onRename();
        } else if (e.key === 'delete' && onDelete && !disableDelete) {
            onDelete();
        } else if (e.key === 'copy' && onCopy) {
            onCopy();
        }
    };

    const handleTriggerClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    // 根据回调函数是否存在动态生成菜单项
    const menuItems = [
        ...(showCopy && onCopy ? [{
            key: 'copy',
            icon: disabled || disableCopy ? <JobCopyDisSvg /> : <CopySvg />,
            label: (
                <Tooltip
                    classNames={{root: styles.copytooltipWrapper}}
                    title={disableCopy && copyDisabledTooltip ? copyDisabledTooltip : ''}
                    placement="right"
                >
                    <div style={{width: '100%'}}>创建副本</div>
                </Tooltip>
            ),
            disabled: disabled || disableCopy
        }] : []),
        onRename && {
            key: 'rename',
            icon: <RenameSvg />,
            label: '重命名',
            disabled: disabled || disableRename
        },
        onDelete && {
            key: 'delete',
            icon: <DeleteSvg />,
            label: '删除',
            disabled: disabled || disableDelete
        }
    ].filter(Boolean);

    if (disabled) {
        return (
            <div className={styles.renameDeleteMenuDisabled}>
                <span>
                    <MoreIcon />
                </span>
            </div>
        );
    }

    return (
        <div
            onClick={handleTriggerClick}
            onMouseDown={handleTriggerClick}
            onMouseUp={handleTriggerClick}
            className={styles.renameDeleteMenu}
        >
            <Dropdown
                menu={{
                    items: menuItems,
                    onClick: handleMenuClick,
                    className: styles.customActionMenu
                }}
                trigger={trigger}
                onOpenChange={onOpenChange}
            >
                <span
                    onClick={handleTriggerClick}
                    onMouseDown={handleTriggerClick}
                >
                    <MoreIcon className={styles.actionIcon} />
                </span>
            </Dropdown>
        </div>
    );
});

export default RenameDeleteMenu;
